module.exports = __webpack_public_path__ + "img/directory.4036cc9.webp";